import { Button, message } from "antd"
import { getImageUrl } from "../../../../../../shared/utils/functions/images"
import BluePlusIcon from '../../../../../../shared/assets/images/bluePlus.svg'
import grayPlusIcon from '../../../../../../shared/assets/images/grayPlusIcon.svg'
import WhiteSendIcon from '../../../../../../shared/assets/images/WhiteSendIcon.svg'
import GrayCheck from '../../../../../../shared/assets/images/GrayCheck.svg'
import { selectEvaluationActionType, selectEvaluationId, selectEvaluationView, selectIsEvaluationQuestionsModal, selectIsIsSuccessSavingEvaluationKitTosStage, selectIsStartingWithEvaluationKit, selectSelectedTemplate, setEvaluationActionType, setEvaluationView, setIsEvaluationQuestionsModal } from "../../../../../interview/slice/interviewSlice"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useMemo } from "react"
import { EvaluationActionType, IEvaluationFooterActionsProps } from "../../../../../../shared/utils/interfaces/evaluation"
import { selectCandidateProfile, setCandidateProfile } from "../../../../slice/candidateSlice"
import { useSendAiInterviewInvitationMutation } from "../../../../../aiInterviewer/slice/aiInterviewApiSlice"
import { useParams } from "react-router-dom"

function EvaluationFooterActions({ saveAsTemplate, handleEvaluationSubmit, isSaveEvaluationDisabled, isLoading, isSuccessSavingEvaluation, isEditing = false }: IEvaluationFooterActionsProps) {
  const dispatch = useDispatch()
  const { applicationId } = useParams()
  const selectTemplate = useSelector(selectSelectedTemplate)
  const evaluationId = useSelector(selectEvaluationId)
  const candidate = useSelector(selectCandidateProfile)
  const isStartingWithEvaluationKit = useSelector(selectIsStartingWithEvaluationKit)
  const isSuccessSavingEvaluationKitTosStage = useSelector(selectIsIsSuccessSavingEvaluationKitTosStage)
  const isEvaluationQuestionModalOpen = useSelector(selectIsEvaluationQuestionsModal)
  const actionType = useSelector(selectEvaluationActionType)
  const isEvaluationViewOpen = useSelector(selectEvaluationView)
  const [sendAiInterviewInvitation, { isLoading: isSending, isSuccess, data, isError, error }] = useSendAiInterviewInvitationMutation()

  const isEvaluationBtnDisabled = useMemo(() => {
    if (isStartingWithEvaluationKit) return isSaveEvaluationDisabled
    else {
      if (!isSuccessSavingEvaluationKitTosStage) return isSaveEvaluationDisabled && isEditing
      else if (isSuccessSavingEvaluationKitTosStage && isEditing) return false
      else return true
    }
  },[isStartingWithEvaluationKit,isSuccessSavingEvaluationKitTosStage,isSaveEvaluationDisabled,isEditing])

  useEffect(() => {
    if (isSuccessSavingEvaluation && candidate?.allowAiInterview) {
      switch (actionType) {
        case EvaluationActionType.saveKit:
          dispatch(setCandidateProfile({ ...candidate, hasKit: true }))
          break;
        case EvaluationActionType.saveEvaluation:
          if (!isStartingWithEvaluationKit) {
            dispatch(setIsEvaluationQuestionsModal(false))
            dispatch(setCandidateProfile({ ...candidate, hasKit: true }))
            dispatch(setEvaluationView(true))

          } else dispatch(setEvaluationView(false))
          break;
        case EvaluationActionType.sendAI:
          !isStartingWithEvaluationKit && sendAIInterview()
          break;
      }
    }
    //eslint-disable-next-line
  }, [isSuccessSavingEvaluation, actionType, dispatch, isStartingWithEvaluationKit])

  useEffect(() => {
    if (isSuccess && candidate?.allowAiInterview) {
      message.success(data?.message, 5)
      dispatch(setEvaluationView(false))
      !isStartingWithEvaluationKit && (dispatch(setIsEvaluationQuestionsModal(false)))
      dispatch(setCandidateProfile({ ...candidate, allowAiInterview: false }))
    }
    //eslint-disable-next-line
  }, [isSuccess, data, dispatch, isStartingWithEvaluationKit])

  useEffect(() => {
    if (isError) {
      message.error(error?.data?.message)
    }
  }, [isError, error])

  const sendAIInterview = async () => {
    await sendAiInterviewInvitation({ applicationId: Number(applicationId) })
  }

  const handleSendAIInterview = () => {
    dispatch(setEvaluationActionType(EvaluationActionType.sendAI))
    isEvaluationQuestionModalOpen && !candidate?.hasKit ? handleEvaluationSubmit() : sendAIInterview()
  }

  return (
    <div className={`items-center ${isStartingWithEvaluationKit ? 'justify-end' : 'justify-between'}  pt-4 border-t flex md:flex-row flex-col gap-3`}>

      {!isStartingWithEvaluationKit &&
        <div className="justify-between hidden gap-3 md:flex">

          <Button
            className={`btn-primary-light disabled:bg-transparent pt-2 pb-7`}
            loading={isLoading && actionType === EvaluationActionType.saveKit}
            disabled={isEvaluationViewOpen || isEvaluationBtnDisabled}
            onClick={() => {
              dispatch(setEvaluationActionType(EvaluationActionType.saveKit))
              handleEvaluationSubmit()
            }}
          >
            Save Kit to Stage
            <img src={isEvaluationViewOpen || isEvaluationBtnDisabled ? grayPlusIcon : BluePlusIcon} className='inline mx-1' alt="+" />
          </Button>
          <Button
            className={`btn-primary-light disabled:bg-transparent pt-2 pb-7`}
            disabled={!!selectTemplate?.key && !isEditing}
            onClick={saveAsTemplate}
          >
            Save as Template
            <img src={!!selectTemplate?.key && !isEditing ? grayPlusIcon : BluePlusIcon} className='inline mx-1' alt="+" />
          </Button>
        </div>}

      <div className="flex flex-col justify-between gap-3 md:flex-row">
        <Button
            className={`btn-primary-light disabled:bg-transparent pt-2 pb-7 block md:hidden`}
            loading={isLoading && actionType === EvaluationActionType.saveKit}
          disabled={isEvaluationViewOpen || isEvaluationBtnDisabled}
            onClick={() => {
              dispatch(setEvaluationActionType(EvaluationActionType.saveKit))
              handleEvaluationSubmit()
            }}
          >
            Save Kit to Stage
          <img src={isEvaluationViewOpen || isEvaluationBtnDisabled ? grayPlusIcon : BluePlusIcon} className='inline mx-1' alt="+" />
          </Button>
          <Button
            className={`btn-primary-light disabled:bg-transparent pt-2 pb-7 block md:hidden`}
            disabled={!!selectTemplate?.key && !isEditing}
            onClick={saveAsTemplate}
          >
            Save as Template
            <img src={!!selectTemplate?.key && !isEditing ? grayPlusIcon : BluePlusIcon} className='inline mx-1' alt="+" />
          </Button>
        <Button
          loading={isLoading && actionType === EvaluationActionType.saveEvaluation}
          disabled={isEvaluationBtnDisabled}
          className='pt-2 btn-primary-light disabled:bg-transparent pb-7 '
          onClick={() => {
            dispatch(setEvaluationActionType(EvaluationActionType.saveEvaluation))
            handleEvaluationSubmit()
          }}
        >
          {isStartingWithEvaluationKit|| isSuccessSavingEvaluationKitTosStage ? "Save Evaluation" : "Evaluate Now"}
          <img src={isEvaluationBtnDisabled ? GrayCheck : getImageUrl('blueCheck')} className='inline ml-2 btn-icon' alt='arrow' />
        </Button>
        {!evaluationId && <Button
          loading={(isLoading && actionType === EvaluationActionType.sendAI) || isSending}
          disabled={(isEvaluationViewOpen ? !isSaveEvaluationDisabled : isSaveEvaluationDisabled && isEditing) || !candidate?.allowAiInterview}
          className="pt-2 pb-7 btn-primary"
          htmlType="submit"
          onClick={handleSendAIInterview}
        >
          Send AI Interview (Myra)
          <img src={WhiteSendIcon} className='inline md:ml-2.5 ml-1' alt="send" />
        </Button>}
      </div>
    </div>
  )
}

export default EvaluationFooterActions